// extracted by mini-css-extract-plugin
module.exports = {"noProductsContainer":"NoProductsPlaceholder_noProductsContainer__iDJPl","icon":"NoProductsPlaceholder_icon__2InZU","noProducts":"NoProductsPlaceholder_noProducts__bihY_"};